/**
 * Load more functionality for list components (Events, News, Podcasts)
 * Handles client-side pagination using partial HTML loading
 */

export function initLoadMoreButtons() {
  const loadMoreButtons = document.querySelectorAll("[data-load-more]");

  loadMoreButtons.forEach((button) => {
    // Remove any existing listeners by cloning the button
    const newButton = button.cloneNode(true) as HTMLButtonElement;
    button.parentNode?.replaceChild(newButton, button);

    newButton.addEventListener("click", async (e) => {
      e.preventDefault();
      const btn = e.currentTarget as HTMLButtonElement;
      const type = btn.getAttribute("data-load-more");
      const currentPage = parseInt(
        btn.getAttribute("data-current-page") || "1",
        10,
      );
      const nextPage = currentPage + 1;

      if (!type) return;

      // Disable button and show loading state
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = "Laden...";

      try {
        // Fetch the next page
        const response = await fetch(`/api/load-more/${type}/${nextPage}`);

        if (!response.ok) {
          throw new Error("Failed to load more items");
        }

        const html = await response.text();

        // Find the container to append items to
        const container = document.querySelector(
          `[data-list-container="${type}"]`,
        );

        if (container) {
          // Create a temporary element to parse the HTML
          const temp = document.createElement("div");
          temp.innerHTML = html;

          // Check for the metadata element to see if there are more pages
          const metadataEl = temp.querySelector(
            "[data-has-next-page]",
          ) as HTMLElement;
          const hasNextPage =
            metadataEl?.getAttribute("data-has-next-page") === "true";

          // Remove the metadata element before appending
          metadataEl?.remove();

          // Append all children to the container
          while (temp.firstChild) {
            container.appendChild(temp.firstChild);
          }

          // Update page number
          btn.setAttribute("data-current-page", String(nextPage));

          // Re-enable button
          btn.disabled = false;
          btn.textContent = originalText;

          // Hide button if no more pages
          if (!hasNextPage) {
            btn.style.display = "none";
          }
        }
      } catch (error) {
        console.error("Error loading more items:", error);
        btn.disabled = false;
        btn.textContent = originalText;
        alert(
          "Fehler beim Laden weiterer Einträge. Bitte versuchen Sie es später erneut.",
        );
      }
    });
  });
}
